/** Parse the admitted Work observation; refused or truncated populations never become empty success. */
import type { WorkItem, WorkObservation } from "./types.js";

type JsonObject = Record<string, unknown>;
function object(value: unknown): JsonObject {
  if (!value || typeof value !== "object" || Array.isArray(value))
    throw new Error("Invalid Work observation object");
  return Object.fromEntries(Object.entries(value));
}
function string(value: unknown): string {
  if (typeof value !== "string") throw new Error("Invalid Work observation text");
  return value;
}
function strings(value: unknown): string[] {
  if (!Array.isArray(value)) throw new Error("Invalid Work observation list");
  return value.map(string);
}
function item(value: unknown): WorkItem {
  const row = object(value);
  if (typeof row["frontier_stale"] !== "boolean" || typeof row["last_sequence"] !== "number")
    throw new Error("Invalid Work observation state");
  return {
    work_id: string(row["work_id"]),
    principal: string(row["principal"]),
    objective: string(row["objective"]),
    work_class: string(row["work_class"]),
    status: string(row["status"]),
    base_frontier: string(row["base_frontier"]),
    frontier_stale: row["frontier_stale"],
    semantic_targets: strings(row["semantic_targets"]),
    dependencies: strings(row["dependencies"]),
    findings: strings(row["findings"]),
    change_intents: strings(row["change_intents"]),
    evidence: strings(row["evidence"]),
    last_sequence: row["last_sequence"],
  };
}
export function parseWorkObservation(value: unknown): WorkObservation {
  const row = object(value);
  if (row["schema"] !== "algodyne.matrix.work-list/v1")
    throw new Error("Unexpected Work observation schema");
  const decision = string(row["decision"]);
  if (decision !== "ready")
    return { project: string(row["project"]), decision, reason: string(row["reason"]), items: [] };
  const population = row["items"] ?? (row["required_items"] === 0 ? [] : null);
  if (!Array.isArray(population)) throw new Error("Ready Work observation lacks its items");
  const items = population.map(item);
  if (row["required_items"] !== items.length) throw new Error("Incomplete Work population refused");
  return { project: string(row["project"]), decision, reason: null, items };
}
